module.exports = __webpack_public_path__ + "c1c3ff263c7338e3c285806a4c5f08dd.pdf";